import React from 'react'
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { up } from "styled-breakpoints";


const FeatureWrap = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5em;

  ${up("sm")} {
    margin-bottom: 0;
  }

`;

const FeatureText= styled.p`
  color: #707070;
  margin: 0;
  flex: 1;
`;

const FeatureIcon = styled.span`
  background: #DBDBDB;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  padding: 0.1em;
  margin-right: 1em;
  width: 50px;
  height: 50px;

  svg {
    width: 100% !important;
  }
`;

const FeatureListItem = (props) => {
  return (
    <FeatureWrap>
      <FeatureIcon>
        <FontAwesomeIcon size='2x' icon={props.icon} />
      </FeatureIcon>
      <FeatureText>{props.text}</FeatureText>
    </FeatureWrap>
  )
}

FeatureListItem.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired
}

export default FeatureListItem
